import { Box } from "@/components/ui/box";
import { Heading } from "@/components/ui/heading";
import { HStack } from "@/components/ui/hstack";
import { Link, LinkText } from "@/components/ui/link";
import { Link as ExpoLink, Href } from "expo-router";
import { VStack } from "@/components/ui/vstack";
import React, { PropsWithChildren } from "react";

export type RestaurantSectionProps = PropsWithChildren & {
  title: string;
  seeAll?: {
    text?: string;
    href: Href;
  };
};

export function RestaurantSection(props: RestaurantSectionProps) {
  return (
    <VStack className="gap-2">
      <HStack className="w-full items-center justify-between">
        <Heading size="xl">{props.title}</Heading>
        {props.seeAll && (
          <ExpoLink href={props.seeAll.href} push>
            <LinkText>{props.seeAll.text ?? "See all"}</LinkText>
          </ExpoLink>
        )}
      </HStack>
      <Box className="p-4 border rounded-md border-background-300">
        {props.children}
      </Box>
    </VStack>
  );
}
